import { Divider, Popover, Typography } from "@mui/material";

import React from "react";
import { View } from "../../View";
import clsx from "clsx";
import { depotSummaryInformation } from "../../../reducers/matrixProfile/selectors";
import { formatMinutesToHHMM } from "../../../utils/date";
import makeStyles from "@mui/styles/makeStyles";
import { numberWithCommas } from "../../../utils/routes";
import { palette } from "../../../theme/palette";
import { useSelector } from "react-redux";

const useStyles = makeStyles(({ typography }) => ({
  container: {
    padding: "15px",
    width: "450px",
    display: "flex",
    fontSize: "13px",
    flexDirection: "column",
    lineHeight: "25px",
  },
  columnsContainer: {
    display: "flex",
    flexDirection: "row",
  },
  column: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  columnWider: {
    flex: 2,
  },
  rowDescriptor: {
    display: "block",
    textAlign: "right",
  },
  rowValue: {
    display: "block",
  },
  textBold: {
    fontWeight: "bold",
    fontSize: "13px",
    display: "inline-block",
    marginRight: "5px",
  },
  divider: {
    height: "0.08rem",
    background: palette.typography.black.disabled,
    margin: "10px 0",
  },
  marginLeft: {
    marginLeft: "10px",
  },
}));

export const SummaryPopover = ({ open, anchorEl, onClose }) => {
  const styles = useStyles();
  const depotSummaryInfo = useSelector(depotSummaryInformation);

  return (
    <Popover
      id={"depotSummaryPopover"}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <View className={styles.container}>
        <View className={styles.columnsContainer}>
          <View className={styles.column}>
            <View className={styles.rowDescriptor}>
              <Typography className={styles.textBold}>Total</Typography>
            </View>
            <View className={styles.rowDescriptor}>
              <Typography className={styles.textBold}>
                Planned (Type)
              </Typography>
            </View>
            <View className={styles.rowDescriptor}>
              <Typography className={styles.textBold}>Left To Plan</Typography>
            </View>
          </View>
          <View className={clsx(styles.column, styles.marginLeft)}>
            <View className={styles.rowValue}>
              <Typography className={styles.textBold}>Drivers:</Typography>{" "}
              {numberWithCommas(depotSummaryInfo?.totalRoutes || 0)}
            </View>
            <View className={styles.rowValue}>
              <Typography className={styles.textBold}>Drivers:</Typography>{" "}
              {numberWithCommas(depotSummaryInfo?.totalAllocated || 0)}
            </View>
            <View className={styles.rowValue}>
              <Typography className={styles.textBold}>Drivers:</Typography>{" "}
              {numberWithCommas(
                (depotSummaryInfo.totalRoutes || 0) -
                  (depotSummaryInfo?.totalAllocated || 0)
              )}
            </View>
          </View>
          <View className={clsx(styles.column)}>
            <View className={styles.rowValue}>
              <Typography className={styles.textBold}>Stops:</Typography>
              {numberWithCommas(depotSummaryInfo?.totalStops || 0)}
            </View>
            <View className={styles.rowValue}>
              <Typography className={styles.textBold}>Stops:</Typography>
              {numberWithCommas(depotSummaryInfo?.plannedStops || 0)}
            </View>
            <View className={styles.rowValue}>
              <Typography className={styles.textBold}>Stops:</Typography>
              {numberWithCommas(
                (depotSummaryInfo?.totalStops || 0) -
                  (depotSummaryInfo?.plannedStops || 0)
              )}
            </View>
          </View>
          <View className={clsx(styles.column)}>
            <View className={styles.rowValue}>
              <Typography className={styles.textBold}>Parcels:</Typography>
              {numberWithCommas(depotSummaryInfo?.totalParcels || 0)}
            </View>
            <View className={styles.rowValue}>
              <Typography className={styles.textBold}>Parcels:</Typography>
              {numberWithCommas(depotSummaryInfo?.plannedParcels || 0)}
            </View>
            <View className={styles.rowValue}>
              <Typography className={styles.textBold}>Parcels:</Typography>
              {numberWithCommas(
                (depotSummaryInfo?.totalParcels || 0) -
                  (depotSummaryInfo?.plannedParcels || 0)
              )}
            </View>
          </View>
        </View>

        <Divider className={styles.divider} />

        <View className={styles.columnsContainer}>
          <View className={styles.columnWider}>
            <View className={styles.rowValue}>
              <Typography className={styles.textBold}>Exceptions:</Typography>
              {`${numberWithCommas(
                depotSummaryInfo.routesWithExceptions || 0
              )}(${numberWithCommas(depotSummaryInfo.totalExceptions || 0)})`}
            </View>
          </View>
          <View className={styles.column}>
            <View className={styles.rowValue}>
              <Typography className={styles.textBold}>Duty:</Typography>
              {formatMinutesToHHMM(depotSummaryInfo.totalAverageDutyTime)}
            </View>
          </View>
          <View className={styles.column}>
            <View className={styles.rowValue}>
              <Typography className={styles.textBold}>OT:</Typography>
              {formatMinutesToHHMM(
                depotSummaryInfo.totalAverageOpportunityMinutes
              )}
            </View>
          </View>
        </View>
      </View>
    </Popover>
  );
};
